import React from "react";
import Container from "./styled";
import { IoClose } from "react-icons/io5";
import BikeAnimation from "./lottieAnimation";

export default function IkeModalStepOne({ handleClose, nextStep, disable }) {
  return (
    <Container className="topInOpacity5">
      <div className="closeButtonContainer">
        <a onClick={handleClose}>
          <IoClose />
        </a>
      </div>
      <img alt="Ike Asistencia Logo" src="images/logos/ike.svg"></img>
      <p>
        A tu SeguroBici, sumale más beneficios con{" "}
        <a href="https://ikeasistencia.com//" target="_blank">
          Iké Asistencia
        </a>
      </p>
      <BikeAnimation></BikeAnimation>
      <button onClick={nextStep}>Conocé más</button>
    </Container>
  );
}
